import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, delay, finalize } from 'rxjs';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { TableHeader } from 'src/app/shared/models/table';
import { REPORT_GROUP_MESSAGES } from 'src/app/util/constantes-mensajes';
import { HelperFunctions } from 'src/app/util/util-functions';
import { v4 as uuidv4 } from 'uuid';
import { ReportGroup } from '../report-group';
import { ReportGroupService } from '../report-group.service';
@Component({
  selector: 'app-manage-report-group',
  templateUrl: './manage-report-group.component.html',
  styleUrls: ['./manage-report-group.component.scss']
})
export class ManageReportGroupComponent implements OnInit, OnDestroy {
  // This property gets the report group to edit
  @Input() reportGroup: ReportGroup;
  // Report group information form
  reportGroupForm: FormGroup;
  // Variable to save filter values
  search$ = new BehaviorSubject<TableHeader | undefined>(undefined);
  // Variable to set modal information
  public modalConfig: ModalConfig;
  // Variable to show/hide spinner
  isLoading: boolean = false;
  // Variable to unsubscribe pending subscriptions
  isAlive: boolean = true;
  // Contains error icon
  faCircleXmark = faCircleXmark;

  constructor(
    private reportGroupService: ReportGroupService,
    private ngbActiveModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.modalConfig = {
      modalTitle: this.reportGroup ? "Editar grupo de reportes" : "Crear grupo de reportes",
      ...this.modalConfig,
    };
    this.initForm();
  }

  /**
  * A function that inits the report group form
  * @returns None
  */
  initForm(): void {
    this.reportGroupForm = new FormGroup({
      uuid: new FormControl(this.reportGroup?.uuid || uuidv4()),
      name: new FormControl(this.reportGroup?.nombre || null, [Validators.required, Validators.maxLength(255)]),
      description: new FormControl(this.reportGroup?.descripcion || null, [Validators.required, Validators.maxLength(255)]),
    });
  }

  /**
  * This function checks if the form control is invalid
  * @param {string} name
  * @returns {boolean}
  */
  hasErrors(name: string): boolean {
    const control = this.reportGroupForm.get(name) as FormControl;
    return HelperFunctions.controlIsInvalid(control);
  }

  /**
  * A function to submit the report group object
  * @returns None
  */
  onSubmit() {
    if (this.reportGroupForm.valid) {
      const groupData = this.reportGroupForm.getRawValue();
      const reportGroup: ReportGroup = {
        uuid: groupData.uuid,
        nombre: groupData.name,
        descripcion: groupData.description
      };
      this.saveReportGroup(reportGroup);
    } else {
      this.reportGroupForm.markAllAsTouched();
    }
  }

  /**
  * This function creates or updates a report group
  * @param {ReportGroup} reportGroup
  */
  saveReportGroup(reportGroup: ReportGroup) {
    this.isLoading = true;
    const subscription = this.reportGroup ? this.reportGroupService.updateReportGroup(reportGroup) : this.reportGroupService.createReportGroup(reportGroup);
    subscription.pipe(
      delay(500),
      finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.ngbActiveModal.close({ message: REPORT_GROUP_MESSAGES.CREATE.REPORT_GROUP, confirmTitle: "Aceptar", isError: false });
        },
        error: (error) => {
          this.ngbActiveModal.close({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
        }
      });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}